import { AGENT_NAV_OPTIONS } from "@/pages/admin/agents/constants";
import AgentProfile from "@/pages/admin/agents/profile/AgentProfile";
import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { CALLOUTS_BASE_LINK } from "@/pages/admin/agents/callouts/config";

const Error404 = lazy(() => import("@/pages/Error404"));
const AgentFinanceDashboard = lazy(() => import("@/pages/admin/agents/finance-dashboard/AgentFinanceDashboard"));
const SupplierSigns = lazy(() => import("@/pages/admin/agents/supplier-signs/SupplierSigns"));
const EditAgent = lazy(() => import("@/pages/admin/agents/edit-agent/EditAgent"));
const ChangeLog = lazy(() => import("@/pages/admin/agents/changelog/ChangeLog"));
const Callouts = lazy(() => import("@/pages/admin/agents/callouts/Callouts"));

const agentsRoutes: RouteObject[] = [
  ...AGENT_NAV_OPTIONS.map((option) => {
    if (option.isIndex) {
      return { index: true, element: option.component ? <option.component /> : <Error404 /> };
    }
    return { path: option.path, element: option.component ? <option.component /> : <Error404 /> };
  }),
  {
    path: "profile",
    element: <AgentProfile />,
  },
  {
    path: "finance-dashboard",
    element: <AgentFinanceDashboard />,
  },
  {
    path: "supplier-signs",
    element: <SupplierSigns />,
  },
  {
    path: "edit",
    element: <EditAgent />,
  },
  {
    path: "changelog",
    element: <ChangeLog />,
  },
  {
    path: "callouts",
    children: [
      { index: true, element: <Navigate to={`${CALLOUTS_BASE_LINK}/founder`} replace /> },
      { path: ":type", element: <Callouts /> },
    ],
  },
];

export default agentsRoutes;
